/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReinsuredPayloadDto
 */
export interface CreateReinsuredPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    status: CreateReinsuredPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    reinsuredGroup: CreateReinsuredPayloadDtoReinsuredGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    legalEntityName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReinsuredPayloadDto
     */
    comment?: string;
}


/**
 * @export
 */
export const CreateReinsuredPayloadDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type CreateReinsuredPayloadDtoStatusEnum = typeof CreateReinsuredPayloadDtoStatusEnum[keyof typeof CreateReinsuredPayloadDtoStatusEnum];

/**
 * @export
 */
export const CreateReinsuredPayloadDtoReinsuredGroupEnum = {
    Aig: 'AIG',
    Allianz: 'Allianz',
    ArabiaInsurance: 'Arabia Insurance',
    AxaXl: 'AXA XL',
    BangkokInsurance: 'Bangkok Insurance',
    Captive: 'Captive',
    Chubb: 'Chubb',
    FalconInsurance: 'Falcon Insurance',
    Fubon: 'Fubon',
    HdiGlobal: 'HDI Global',
    Hollard: 'Hollard',
    HyundaiInsurance: 'Hyundai Insurance',
    KbInsurance: 'KB Insurance',
    MitsuiSumitomo: 'Mitsui Sumitomo',
    NewIndia: 'New India',
    OmanInsurance: 'Oman Insurance',
    Other: 'Other',
    Samsung: 'Samsung',
    Scor: 'SCOR',
    Sompo: 'SOMPO',
    Starr: 'Starr',
    TokioMarine: 'Tokio Marine',
    Vero: 'Vero',
    Zurich: 'Zurich'
} as const;
export type CreateReinsuredPayloadDtoReinsuredGroupEnum = typeof CreateReinsuredPayloadDtoReinsuredGroupEnum[keyof typeof CreateReinsuredPayloadDtoReinsuredGroupEnum];


/**
 * Check if a given object implements the CreateReinsuredPayloadDto interface.
 */
export function instanceOfCreateReinsuredPayloadDto(value: object): value is CreateReinsuredPayloadDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('reinsuredGroup' in value) || value['reinsuredGroup'] === undefined) return false;
    if (!('legalEntityName' in value) || value['legalEntityName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CreateReinsuredPayloadDtoFromJSON(json: any): CreateReinsuredPayloadDto {
    return CreateReinsuredPayloadDtoFromJSONTyped(json, false);
}

export function CreateReinsuredPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReinsuredPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'reinsuredGroup': json['reinsuredGroup'],
        'legalEntityName': json['legalEntityName'],
        'name': json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'country': json['country'],
        'city': json['city'] == null ? undefined : json['city'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function CreateReinsuredPayloadDtoToJSON(json: any): CreateReinsuredPayloadDto {
    return CreateReinsuredPayloadDtoToJSONTyped(json, false);
}

export function CreateReinsuredPayloadDtoToJSONTyped(value?: CreateReinsuredPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reinsuredGroup': value['reinsuredGroup'],
        'legalEntityName': value['legalEntityName'],
        'name': value['name'],
        'address': value['address'],
        'country': value['country'],
        'city': value['city'],
        'postcode': value['postcode'],
        'comment': value['comment'],
    };
}

